/** Returns the values of an object. */
export function values(object: any): any[] {
    const vals = [];
    for (const key of Object.keys(object)) {
        vals.push(object[key]);
    }
    return vals;
}
